export type ImplLabel = "Not Implemented" | "Partially Implemented" | "Implemented";

export const implToScore: Record<ImplLabel, number> = {
  "Not Implemented": 0,
  "Partially Implemented": 50,
  "Implemented": 100,
};

export function scoreToImpl(score?: number | null): ImplLabel | "" {
  if (score == null) return "";
  if (score === 0) return "Not Implemented";
  if (score === 100) return "Implemented";
  return "Partially Implemented"; // any other value becomes 'Partial' for high-level reporting
}